import React from 'react';
import { parseBlogInlineFormatting, splitBlogContent } from '@/utils/blog';

const BlogPostContent = ({ content, emptyMessage = 'Contenu non disponible.' }) => {
  const paragraphs = splitBlogContent(content);

  if (paragraphs.length === 0) {
    return <p className="text-sm text-slate-500">{emptyMessage}</p>;
  }

  return (
    <div className="space-y-5 text-base leading-8 text-slate-700">
      {paragraphs.map((paragraph, index) => (
        <p key={`${index}-${paragraph.slice(0, 20)}`} className="whitespace-pre-line">
          {parseBlogInlineFormatting(paragraph).map((segment, segmentIndex) => (
            segment.bold ? (
              <strong key={`${segmentIndex}-${segment.text.slice(0, 12)}`} className="font-semibold text-slate-900">
                {segment.text}
              </strong>
            ) : (
              <React.Fragment key={`${segmentIndex}-${segment.text.slice(0, 12)}`}>
                {segment.text}
              </React.Fragment>
            )
          ))}
        </p>
      ))}
    </div>
  );
};

export default BlogPostContent;
